module.exports = __webpack_public_path__ + "roboto-light-webfont.ec0691a96da4c123a2cf.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/assets/fonts/roboto-light-webfont.woff
// module id = ../../../../../src/assets/fonts/roboto-light-webfont.woff
// module chunks = styles